<template>
  <main>
    <div class="row">

      <div class="col s12 l10 offset-l1 card-panel recargas" style="border-radius: 20px; position: relative">
        <h3 class="page-title" style="text-align: center "> Recargas por tipo de carrier</h3>
        <span class=" titulo center-align">Registrar nuevo usuario</span>
        <div class="row">
          <div class="col s3">
          </div>
          <div class="col s6">
            <div class="input-field col s12">

              <input v-model="username" id="username" type="text" maxlength="50">
              <label for="username">Username</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s3">
          </div>
          <div class="col s6">
            <div class="input-field col s12 ">

              <input v-model="canal" id="canal" type="text" maxlength="50">
              <label for="canal">Canal u Operador(Opcional)</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s3">

          </div>
          <div class="col s6">
            <div class="input-field col s12">
              <select v-model="plataforma">
                <option value="" disabled selected>Selecciona la plataforma</option>
                <option v-for="p in plataformas" :value="p">{{ p }}</option>
              </select>
              <label>Plataforma</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col s7">

          </div>
          <div class="col s3">
            <div class="waves-effect waves-light btn-large blue-grey darken-3   "

                 @click="registrar"><i class="fa fa-check left" aria-hidden="true"></i> Registrar
            </div>
          </div>
        </div>

        <h5 style="color: #7a0f19; text-align: center">{{ error }}</h5>
      </div>
    </div>
  </main>
</template>

<script>
import {plataformasEmpresa, addPlataformasEmpresa} from "@/api/api";

export default {
  name: "nuevoUsuarioPlataforma",
  data() {
    return {
      username: ``,
      canal: ``,
      plataforma: ``,
      plataformas: [],
      error: ``
    }
  },
  methods: {
    registrar() {
      if (!this.username.length) return this.error = `Debes poner un username`
      if (!this.plataforma.length) return this.error = `Debes selecionar una plataforma`
      else {
        this.error = ``
        addPlataformasEmpresa(this.username, this.plataforma, this.canal).then(()=>{
          this.$router.push({name: `recargasCarier`})
        }).catch(error=>{
          let auxMessage = `Ocurrio un error`
          if (error.mensaje) auxMessage = error.mensaje
          M.toast({html: `${auxMessage}`, classes: 'rounded', displayLength: 150000})
          console.log(error)
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      plataformasEmpresa().then(resp => {
        console.log(resp)
        resp.data.forEach(p => {
          if (!this.plataformas.find(tp => tp == p.plataforma))
            this.plataformas.push(p.plataforma)
        })
        console.log(this.plataformas)
        setTimeout(() => {
          M.AutoInit()
        }, 200)
      }).catch(error => {
        let auxMessage = `Ocurrio un error`
        if (error.mensaje) auxMessage = error.mensaje
        M.toast({html: `${auxMessage}`, classes: 'rounded', displayLength: 150000})
        console.log(error)
      })
    })
  },
}
</script>

<style scoped>
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-flex;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
</style>